<template>
  <div class="fixed top-0 right-0 z-70 hidden w-full justify-end unactive_side_cart" id="js_side_cart" style="min-height: var( --app-height);">

    <div class="relative z-10 bg-white w-s300 px-s20 pt-s20 pb-s60 m_650:pt-s20 m_650:pb-s60 m_650:w-s600 side_cart_content" style="min-height: var( --app-height);">
      <div class="top pb-s15 flex justify-between items-center m_650:pb-s20">
        <p class="text-t18 font-medium uppercase m_650:text-t20">Moja korpa</p>
        <button type="button" class="text-black js_close_side_cart">
          <close-icon svgClassName="size-s20 m_650:size-s25"></close-icon>
        </button>
      </div>

      <template v-if="getCartItemsCount > 0">
        <div class="w-full">
          <div class="side_element_items overflow-y-scroll w-full">
            <div
              class="p-s20 ml-0 border-t border-light-gray last-of-type:border-b grid m_650:grid-cols-side-cart-product m_650:gap-s30"
              v-for="(item, index) in getCartItems" :key="index">
              <a :href="item.options.path">
                <img :src="item.options.thumbnail" :alt="item.name" width="120" height="182" class="mx-auto w-s80 m_650:w-full" loading="lazy">
              </a>

              <div>
                <div class="mb-s20 flex justify-between gap-s20">
                  <div>
                    <p class="font-medium">{{ item.options.brend }}</p>
                    <p class="break-all"><a :href="item.options.path">{{ item.name }}</a></p>
                    <p>Boja: {{ item.options.color }}</p>
                    <p>Veličina: {{ item.options.size }}</p>
                  </div>

                  <button type="button" class="text-black self-center m_650:self-start">
                    <remove-icon :index="index" svgClassName="size-s20 m_650:size-s25" :product="item"></remove-icon>
                  </button>
                </div>

                <div class="flex justify-between items-center">
                  <div class="flex items-center gap-s10 m_650:gap-s5">
                    <button type="button" class="text-t24 font-light leading-6 size-s25" @click="reduce(item)">-
                    </button>
                    <p>{{ item.qty }}</p>
                    <button type="button" class="text-t24 font-light leading-6 size-s25" @click="increase(item)">+
                    </button>
                  </div>

                  <p class="text-t16">{{ formatPrice(item.options.final_price) }} rsd</p>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="bg-white py-s15 text-right justify-self-end m_650:py-s20">
          <p class="text-t16 m_650:text-t18">Ukupan iznos:</p>
          <p class="text-t16 m_650:text-t18 font-medium">{{ formatPrice(getTotalPrice) }} RSD</p>
        </div>

      </template>

      <template v-else>
        <p>Vaša korpa je prazna</p>
      </template>

      <a v-if="getCartItemsCount > 0" href="/pregled" class="bg-black w-full text-white text-t18 text-center py-s15 cursor-pointer absolute bottom-0 left-0 m_650:text-t20 m_650:py-s20">
        IDI NA PLAĆANJE
      </a>

      <a v-else href="/" class="bg-black w-full text-white text-t18 text-center py-s15 cursor-pointer absolute bottom-0 left-0 m_650:text-t20 m_650:py-s20">
        IDI NA HOME
      </a>
    </div>

    <div class="bg-black/70 cursor-pointer absolute top-0 left-0 w-full h-full js_close_side_cart"></div>

  </div>
</template>

<script>
import RemoveIcon from '../svg/RemoveIcon.vue';
import CloseIcon from '../svg/CloseIcon.vue';
import accounting from 'accounting';

export default {
  name: "SideCart",
  components: {
    RemoveIcon,
    CloseIcon,
  },

  computed: {

    /**
     * Retrieve cart items from vuex store
     * That means on every change of vuex state, retrieve changes...
     */
    getCartItems() {

      return this.$store.getters['Cart/getCartItems'];
    },

    /**
     * Retrieve cart items count from vuex store
     */
    getCartItemsCount() {
      return this.$store.getters['Cart/getItemCount'];
    },

    /**
     * Retrieve cart items total price from vuex store
     */
    getTotalPrice() {
      return this.$store.getters['Cart/getTotalPrice'];
    },

  },

  methods: {

    /**
     * Format price.
     *
     * @param value
     */
    formatPrice(value) {

      return accounting.formatMoney(value, '', 2, '.', ',')
    },

	  /**
	   * Format price for google.
	   *
	   * @param value
	   */
	  formatPriceForGoogle(value) {

		  return accounting.formatMoney(value, '', 2, '', '.')
	  },

    reduce(item) {
      item.qty--;

      this.updateShoppingCart(item);
    },

    increase(item) {
      item.qty++;

	    dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
	    dataLayer.push({
		    event: "add_to_cart",
		    ecommerce: {
			    currency: "RSD",
			    value: this.formatPriceForGoogle(item.price),
			    items: [
				    {
					    item_name: item.name,
					    item_id: item.options.movem_id,
					    item_brand: item.options.brend,
					    price:  this.formatPriceForGoogle(item.price),
					    quantity: item.qty
				    }
			    ]
		    }
	    });

      this.updateShoppingCart(item);
    },

    /**
     * Update Shopping cart by sending request to backend.
     *
     * @param item
     */
    updateShoppingCart(item) {

      axios.post('/dodaj-u-korpu/' + item.rowId, { qty: item.qty })
        .then(response => {

					// Preview message
          this.$toasted.global.toastSuccess({ message: response.data.message });

          // Update vuex store
          this.$store.dispatch('Cart/changeCartItems', response.data.cartItems);
          this.$store.dispatch('Cart/changeItemCount', response.data.cartItemsCount);
          this.$store.dispatch('Cart/changeTotalPrice', response.data.totalPrice);
          this.$store.dispatch('Cart/changeSubtotalPrice', response.data.subtotalPrice);
        })
        .catch(error => {

          item.qty--;

          // Update vuex store
          this.$store.dispatch('Cart/changeCartItems', error.response.data.cartItems);
          this.$store.dispatch('Cart/changeItemCount', error.response.data.cartItemsCount);
          this.$store.dispatch('Cart/changeTotalPrice', error.response.data.totalPrice);
          this.$store.dispatch('Cart/changeSubtotalPrice', response.data.subtotalPrice);

        })
    },
  }
}
</script>

<style scoped>
.unactive_side_cart .side_cart_content{animation:sideCart ease-in-out 500ms;animation-iteration-count:1;animation-fill-mode:forwards}@keyframes sideCart{0%{transform:translatex(100%)}100%{transform:translatex(0%)}}.side_element_items{scrollbar-width:auto;scrollbar-color:#D9D9D9 #fff;max-height:calc(var( --app-height) - 225px)}.side_element_items::-webkit-scrollbar{width:12px}.side_element_items::-webkit-scrollbar-track{background:#fff}.side_element_items::-webkit-scrollbar-thumb{background-color:#D9D9D9;border-radius:0;border-left:1px solid #fff;border-right:1px solid #fff}@media(max-width:650px){.side_element_items{max-height:calc(var( --app-height) - 180px)}}
</style>